import { usefulConcerts } from './entityHubRenderable.js';
import { safeMediaUrl } from './mediaUrl.js';
import { looksLikeSharedTourArt } from './personHeroCover.js';

function concertStartMs(concert) {
  if (!concert?.startsAt) return Number.NaN;
  const ms = Date.parse(concert.startsAt);
  return Number.isNaN(ms) ? Number.NaN : ms;
}

export function upcomingConcertsFromHub(hub, now = new Date()) {
  const nowMs = now.getTime();
    const artistImage = hub?.entity?.imageUrl;
  return usefulConcerts(hub)
    .filter((concert) => {
      if (concert.kind === 'past') return false;
      const startMs = concertStartMs(concert);
      if (Number.isFinite(startMs)) return startMs > nowMs;
      return concert.kind === 'upcoming' || concert.kind === 'concert';
    })
    .map((concert) => {
      const start = concert.startsAt;
      const startMs = concertStartMs(concert);
      const end = Number.isFinite(startMs)
        ? new Date(startMs + 3 * 60 * 60 * 1000).toISOString()
        : start;
      const venueImage = looksLikeSharedTourArt(hub, concert.venueImageUrl)
        ? null
        : safeMediaUrl(concert.venueImageUrl);
      const eventArt = looksLikeSharedTourArt(hub, concert.imageUrl)
        ? null
        : safeMediaUrl(concert.imageUrl);
      const image = venueImage || eventArt || safeMediaUrl(artistImage);
      return {
        id: concert.id || `concert-${concert.title}-${concert.startsAt}`,
        title: concert.title || concert.venueName || 'Concert',
        platform: 'concert',
        type: 'Upcoming',
        start,
        end,
        url: concert.url || null,
        thumbnail: image,
        logo: image,
        venueName: concert.venueName || null,
        city: concert.city || null,
        channelName: [concert.venueName, concert.city].filter(Boolean).join(' · ') || null,
        matchKind: 'direct',
        kind: 'concert',
        entityId: hub?.entity?.id || null,
      };
    });
}
